<template>
    <a-modal v-model="visible" title="模块列表" width="900px" okText="关闭" :footer="null" @cancel="handleCancel">
        <a-table  :scroll="{  y: 640 }" :columns="columns" :data-source="data" style="margin-top: 20px;"   :loading="loading" :pagination="pagination" :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange,  getCheckboxProps: getCheckboxProps}" rowKey="moduleCode" >
        <span slot="allowDerived" slot-scope="text,record">{{record.allowDerived ? '是' : '否'}}</span>
        </a-table>
        <a-row>
            <a-popconfirm
                title="确认授予？"
                ok-text="是"
                cancel-text="否"
                @confirm="grantModule(record)"
                style="margin-right: 10px;float:right;"
            >
                <a-button type="primary">点击授予</a-button>
            </a-popconfirm>
        </a-row>
    </a-modal>
</template>

<script>
const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
        console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
    },
    onSelect: (record, selected, selectedRows) => {
        console.log(record, selected, selectedRows);
    },
    onSelectAll: (selected, selectedRows, changeRows) => {
        console.log(selected, selectedRows, changeRows);
    },
    getCheckboxProps: record => ({
        props: {
        disabled: !record.allowDerived, // Column configuration not to be checked
        },
    }),
};
import {  queryUserModuleListApi, grantUserModuleApi, querySubUserModuleListApi} from '@/api/user'
export default {
    data() {
        return{
            selectedRows: [],
            currentUserModules: [],
            selectedRowKeys: [],
            rowSelection,
            visible: false,
            record: {},
            params: { page: 1, limit: 10},
            loading: false,
            pagination: {
                pageSize: 30,
                current: 1,
                showQuickJumper: true,
                onChange: (current) => this.changePage(current),
            },
            columns: [
                {
                    title: '模块编码',
                    dataIndex: 'moduleCode',
                    key: 'moduleCode'
                },
                {
                    title: '模块名称',
                    dataIndex: 'moduleName',
                    key: 'moduleName'
                },
                {
                    title: '是否允许派生',
                    dataIndex: 'allowDerived',
                    scopedSlots: { customRender: 'allowDerived' },
                },
                {
                    title: '操作',
                    dataIndex: 'action',
                    scopedSlots: { customRender: 'action' },
                }
            ],
            data: []
        }
    },
    methods: {
        handleCancel() {
            this.selectedRowKeys = []
            this.selectedRows = []
        },
        getCheckboxProps(record){
            return ({
                props: {
                    disabled: !record.allowDerived
                }
            })
        },
        onSelectChange(selectedRowKeys, selectedRows) {
            this.selectedRowKeys = selectedRowKeys;
            this.selectedRows = selectedRows
            console.log(selectedRows)
            console.log(selectedRowKeys)
        },
        showModule(record) {
            this.visible = true
            this.record = record
            this.queryUserModuleList()
            this.querySubUserModuleList()
        },
        querySubUserModuleList() {
            querySubUserModuleListApi({userCode: this.record.userCode}).then(res => {
                this.currentUserModules = res.result
                this.selectedRowKeys = this.currentUserModules
            })
        },
        queryUserModuleList() {
            this.loading = true
            this.params.page = this.pagination.current
            this.params.limit = this.pagination.pageSize
            queryUserModuleListApi({...this.params}).then(res => {
                this.data = res.result
                this.loading = false
            })
        },
        grantModule(){
            grantUserModuleApi({userCode: this.record.userCode, moduleCode: this.selectedRowKeys}).then(res => {
                this.$message.success('操作成功')
                this.$emit('query')
                this.selectedRowKeys = []
                this.selectedRows = []
                this.visible = false
            }).catch(() => {
                this.$message.error('操作失败')
            })
        },
        changePage(current) {
            this.pagination.current = current
            this.queryUserModuleList()
        },
    }
}
</script>